import { useCallback } from "react";
import { useMessage } from "./useMessage";

let definitionToReuse: eXpress.core.IDefinition | undefined;
export function useResetDefinitionForOptions() {
	const setDefinition = useCallback((def: eXpress.core.IDefinition | undefined) => {
		definitionToReuse = def;
	}, []);

	useMessage(
		useCallback((message) => {
			// If another commands is executed, don't reuse cloned definition but the latest definition
			if (
				!(message instanceof eXpress.core.AlternativeProductSwitchedMessage) &&
				eXpress.core.isCommandMessage(message)
			) {
				definitionToReuse = undefined;
			}
		}, []),
	);

	return [definitionToReuse, setDefinition] as const;
}
